import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { Routes as CommerceRoutes } from './routes';
import { CommerceRouterCmp } from './types';
import { MyChannels } from '../pages/MyChannelsPage';
import { SecureRoute } from 'ui/components/Route';
import { isTestEnv } from 'services/api/testEnv';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const CommerceRouter: CommerceRouterCmp = () => {
  return (
    <Routes>
      <Route
        element={
          <SecureRoute
            redirectToHome={isTestEnv()}
            requiredFeature="canAccessIntegrations"
          />
        }
      >
        <Route path={MyChannels.route} element={<MyChannels />} />
      </Route>
    </Routes>
  );
};

CommerceRouter.route = CommerceRoutes.CommerceRouter;

export default CommerceRouter;
